export const getOrderProductPreQuery = (orderType) =>
  orderType === "TRANSFER" ? undefined : { status: "ACTIVE" };

export const getConsultantProductPreQuery = () => ({
  status: ["ACTIVE", "INACTIVE", "DFT"],
});

export const getProductId = (product) => {
  if (!product) return null;
  if (typeof product === "object") {
    return product._id ? String(product._id) : null;
  }
  return String(product);
};

export const isProductAllowedForOrderType = (
  productStatus,
  orderType,
  { existingOrder, selectedProductId, originalProductId } = {}
) => {
  if (orderType === "TRANSFER" || !productStatus || productStatus === "ACTIVE") {
    return true;
  }
  // Existing New Biz orders may keep the product that was active at create time.
  if (!existingOrder) return false;
  if (!originalProductId) return true;
  const selectedId = getProductId(selectedProductId);
  const originalId = getProductId(originalProductId);
  return Boolean(selectedId && originalId && selectedId === originalId);
};

export const isMpfProduct = (formValues) =>
  formValues?.productSnapShot?.category?.code === "MPF";

export const isIlasProduct = (formValues) =>
  formValues?.productSnapShot?.category?.code === "ILAS" ||
  formValues?.productCategory?.code === "ILAS" ||
  formValues?.product?.category?.code === "ILAS";

export const isInvestmentTransactionsProduct = (formValues) =>
  formValues?.productType?.investmentTransactions === true ||
  formValues?.productSnapShot?.type?.investmentTransactions === true ||
  formValues?.product?.type?.investmentTransactions === true;

export const isMortgageeHirePurchaseProduct = (formValues) =>
  formValues?.productType?.mortgageeHirePurchase === true ||
  formValues?.productSnapShot?.type?.mortgageeHirePurchase === true ||
  formValues?.product?.type?.mortgageeHirePurchase === true;

export const getOrderPolicyNumberLabel = (formValues) =>
  isInvestmentTransactionsProduct(formValues)
    ? "Account Number"
    : "Policy Number";
